"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _react.default.createElement("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12"
}, _react.default.createElement("path", {
  d: "M6 1.5c-2.92 0-4.36.9-4.87 1.47a.1.1 0 00-.03.06c0 .02 0 .05.03.08C1.62 3.83 3.04 5 6 5s4.38-1.17 4.87-1.89a.13.13 0 00.03-.08.1.1 0 00-.03-.06C10.37 2.41 8.92 1.5 6 1.5zm-5.61.8C1.14 1.47 2.89.5 6 .5c3.12 0 4.86.97 5.61 1.8.36.4.37.96.09 1.37C11 4.71 9.23 6 6 6S1 4.7.3 3.67A1.1 1.1 0 01.4 2.3zM.5 8c.28 0 .5.22.5.5v.07c0 .32.08.55.23.69C1.75 9.75 3 10.5 6 10.5c3 0 4.25-.75 4.77-1.24.15-.14.23-.37.23-.7V8.5a.5.5 0 011 0v.07c0 .46-.12 1.02-.54 1.42-.77.72-2.3 1.51-5.46 1.51S1.3 10.7.54 9.99C.12 9.59 0 9.03 0 8.57V8.5c0-.28.22-.5.5-.5zM1 5.75a.5.5 0 00-1 0v.07c0 .46.12 1.02.54 1.42.77.72 2.3 1.51 5.46 1.51s4.7-.8 5.46-1.51c.42-.4.54-.96.54-1.42v-.07a.5.5 0 00-1 0v.07c0 .32-.08.55-.23.69C10.25 7 9 7.75 6 7.75c-3 0-4.25-.75-4.77-1.24-.15-.14-.23-.37-.23-.7v-.06z"
}));

exports.default = _default;